import { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { MilestoneGroup } from "./grouping-milestone";
import { getGroupings } from "./Groupmilestones.service";

/**
 * Owns the grouping table data: fetching, loading state, and debounced search.
 * The component drives the drawer/form; this hook only handles table data.
 */
export function useGroupMilestones() {
    const [milestoneData, setMilestoneData] = useState<MilestoneGroup[]>([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");

    const fetchMilestones = useCallback(async (search: string) => {
        setLoading(true);
        try {
            const rows = await getGroupings(search);
            setMilestoneData(rows);
        } catch (err) {
            toast.error("Failed to fetch milestones.");
        } finally {
            setLoading(false);
        }
    }, []);

    // debounce the search input
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchQuery);
        }, 500);
        return () => clearTimeout(handler);
    }, [searchQuery]);

    // fetch whenever the debounced value changes
    useEffect(() => {
        fetchMilestones(debouncedSearch);
    }, [debouncedSearch, fetchMilestones]);

    return {
        milestoneData,
        loading,
        searchQuery,
        setSearchQuery,
        debouncedSearch,
        fetchMilestones,
    };
}